module.exports = __webpack_public_path__ + "static/media/success.5eb68bf7.svg";